<app-loader></app-loader>
<router-outlet></router-outlet>
<app-kiosk-error></app-kiosk-error>
<app-keyboard-input></app-keyboard-input>
